module.exports = __webpack_public_path__ + "img/Opera.94a28bd9.svg";